<div class="level-container">
	@if (showPriorityText && levelValue) {
		<p class="level-text">
			{{ colorsMap[levelValue].text | translate }}
		</p>
	}
	@for (_ of array; track _) {
		<span
			class="level-element"
			[ngStyle]="{ 'background-color': colorsMap[levelValue].color }"
		></span>
	}

	@if (!levelValue) {
		<span>
			<div class="no-data">{{ fallbackText }}</div>
		</span>
	}
</div>
